export default "/kiban/_next/static/images/aluminum-649cab62a9cfc66e297a1448a5cbe93a.png";